import { SeatFaresFormInterface } from 'common/lineForm.interface';
import { LineStopBaseInterface, LineBaseInterface } from '../lines/types';
import { StopInterface } from '../stops/types';

/*
 * Action Types
 */
export enum ItinerariesTypes {
  LIST_ITINERARIES_REQUEST = '@itinerary/LIST_ITINERARIES_REQUEST',
  LIST_ITINERARIES_SUCCESS = '@itinerary/LIST_ITINERARIES_SUCCESS',
  LIST_ITINERARIES_FAILURE = '@itinerary/LIST_ITINERARIES_FAILURE',

  LIST_ITINERARIES_BY_WEEKDAYS_REQUEST = '@itinerary/LIST_ITINERARIES_BY_WEEKDAYS_REQUEST',
  LIST_ITINERARIES_BY_WEEKDAYS_SUCCESS = '@itinerary/LIST_ITINERARIES_BY_WEEKDAYS_SUCCESS',
  LIST_ITINERARIES_BY_WEEKDAYS_FAILURE = '@itinerary/LIST_ITINERARIES_BY_WEEKDAYS_FAILURE',

  GET_ITINERARY_REQUEST = '@itinerary/GET_ITINERARY_REQUEST',
  GET_ITINERARY_SUCCESS = '@itinerary/GET_ITINERARY_SUCCESS',
  GET_ITINERARY_FAILURE = '@itinerary/GET_ITINERARY_FAILURE',

  FILTER_ITINERARIES_REQUEST = '@itinerary/FILTER_ITINERARIES_REQUEST',
  FILTER_ITINERARIES_SUCCESS = '@itinerary/FILTER_ITINERARIES_SUCCESS',
  FILTER_ITINERARIES_FAILURE = '@itinerary/FILTER_ITINERARIES_FAILURE',

  CREATE_ITINERARY_REQUEST = '@itinerary/CREATE_ITINERARY_REQUEST',
  CREATE_ITINERARY_SUCCESS = '@itinerary/CREATE_ITINERARY_SUCCESS',
  CREATE_ITINERARY_FAILURE = '@itinerary/CREATE_ITINERARY_FAILURE',

  UPDATE_ITINERARY_REQUEST = '@itinerary/UPDATE_ITINERARY_REQUEST',
  UPDATE_ITINERARY_SUCCESS = '@itinerary/UPDATE_ITINERARY_SUCCESS',
  UPDATE_ITINERARY_FAILURE = '@itinerary/UPDATE_ITINERARY_FAILURE',

  DELETE_ITINERARY_REQUEST = '@itinerary/DELETE_ITINERARY_REQUEST',
  DELETE_ITINERARY_SUCCESS = '@itinerary/DELETE_ITINERARY_SUCCESS',
  DELETE_ITINERARY_FAILURE = '@itinerary/DELETE_ITINERARY_FAILURE',

  RESUME_ITINERARY_REQUEST = '@itinerary/RESUME_ITINERARY_REQUEST',
  RESUME_ITINERARY_SUCCESS = '@itinerary/RESUME_ITINERARY_SUCCESS',
  RESUME_ITINERARY_FAILURE = '@itinerary/RESUME_ITINERARY_FAILURE',

  SET_CURRENT_LINE = '@itinerary/SET_CURRENT_LINE',

  RESUME_ITINERARY_TRIP_CAPACITY_REQUEST = '@itinerary/RESUME_ITINERARY_TRIP_CAPACITY_REQUEST',
  RESUME_ITINERARY_TRIP_CAPACITY_SUCCESS = '@itinerary/RESUME_ITINERARY_TRIP_CAPACITY_SUCCESS',
  RESUME_ITINERARY_TRIP_CAPACITY_FAILURE = '@itinerary/RESUME_ITINERARY_TRIP_CAPACITY_FAILURE',

  PEDESTRIAN_TOKENS_REQUEST = '@itinerary/PEDESTRIAN_TOKENS_REQUEST',
  PEDESTRIAN_TOKENS_SUCCESS = '@itinerary/PEDESTRIAN_TOKENS_SUCCESS',
  PEDESTRIAN_TOKENS_FAILURE = '@itinerary/PEDESTRIAN_TOKENS_FAILURE',

  VEHICLE_TOKENS_REQUEST = '@itinerary/VEHICLE_TOKENS_REQUEST',
  VEHICLE_TOKENS_SUCCESS = '@itinerary/VEHICLE_TOKENS_SUCCESS',
  VEHICLE_TOKENS_FAILURE = '@itinerary/VEHICLE_TOKENS_FAILURE',

  RESCHEDULE_TOKEN_REQUEST = '@itinerary/RESCHEDULE_TOKEN_REQUEST',
  RESCHEDULE_TOKEN_SUCCESS = '@itinerary/RESCHEDULE_TOKEN_SUCCESS',
  RESCHEDULE_TOKEN_FAILURE = '@itinerary/RESCHEDULE_TOKEN_FAILURE',

  SEAT_PRE_RESERVE_REQUEST = '@itinerary/SEAT_PRE_RESERVE_REQUEST',
  SEAT_PRE_RESERVE_SUCCESS = '@itinerary/SEAT_PRE_RESERVE_SUCCESS',
  SEAT_PRE_RESERVE_FAILURE = '@itinerary/SEAT_PRE_RESERVE_FAILURE',

  FILTER_VEHIVLE_LICENSE_REQUEST = '@itinerary/FILTER_VEHIVLE_LICENSE_REQUEST',
  FILTER_VEHIVLE_LICENSE_SUCCESS = '@itinerary/FILTER_VEHIVLE_LICENSE_SUCCESS',
  FILTER_VEHIVLE_LICENSE_FAILURE = '@itinerary/FILTER_VEHIVLE_LICENSE_FAILURE',

  TOKEN_LIST_REQUEST = '@itinerary/TOKEN_LIST_REQUEST',
  TOKEN_LIST_SUCCESS = '@itinerary/TOKEN_LIST_SUCCESS',
  TOKEN_LIST_FAILURE = '@itinerary/TOKEN_LIST_FAILURE',

  USER_TRASACTION_LIST_REQUEST = '@itinerary/USER_TRASACTION_LIST_REQUEST',
  USER_TRASACTION_LIST_SUCCESS = '@itinerary/USER_TRASACTION_LIST_SUCCESS',
  USER_TRASACTION_LIST_FAILURE = '@itinerary/USER_TRASACTION_LIST_FAILURE',

  CANCEL_BOOKED_TOKEN_REQUEST = '@itinerary/CANCEL_BOOKED_TOKEN_REQUEST',
  CANCEL_BOOKED_TOKEN_SUCCESS = '@itinerary/CANCEL_BOOKED_TOKEN_SUCCESS',
  CANCEL_BOOKED_TOKEN_FAILURE = '@itinerary/CANCEL_BOOKED_TOKEN_FAILURE',

  BPE_LIST_REQUEST = '@itinerary/BPE_LIST_REQUEST',
  BPE_LIST_SUCCESS = '@itinerary/BPE_LIST_SUCCESS',
  BPE_LIST_FAILURE = '@itinerary/BPE_LIST_FAILURE',

  GET_BPE_PDF_REQUEST = '@itinerary/GET_BPE_PDF_REQUEST',
  GET_BPE_PDF_SUCCESS = '@itinerary/GET_BPE_PDF_SUCCESS',
  GET_BPE_PDF_FAILURE = '@itinerary/GET_BPE_PDF_FAILURE',

  GET_3DS_TOKEN_REQUEST = '@itinerary/GET_3DS_TOKEN_REQUEST',
  GET_3DS_TOKEN_SUCCESS = '@itinerary/GET_3DS_TOKEN_SUCCESS',
  GET_3DS_TOKEN_FAILURE = '@itinerary/GET_3DS_TOKEN_FAILURE',

  STOP_DEPARTURES_REQUEST = '@itinerary/STOP_DEPARTURES_REQUEST',
  STOP_DEPARTURES_SUCCESS = '@itinerary/STOP_DEPARTURES_SUCCESS',
  STOP_DEPARTURES_FAILURE = '@itinerary/STOP_DEPARTURES_FAILURE',
}

/*
 * Data types
 */
export interface ItineraryLineStopInterface {
  id: string;
  title: string;
  hour: string;
  row: number;
  platform: string | null;
  createdAt: string;
  updatedAt: string;
  itineraryId: string;
  lineStopId: string;
  LineStop: LineStopBaseInterface & {
    Stop: StopInterface;
  };
}

export interface ItineraryInterface {
  id: string;
  name: string;
  weekdays: Array<string>;
  status: number;
  departureTime: string;
  arrivalTime: string;
  lineId: string;
  lineSectionId: string;
  createdAt: string;
  updatedAt: string;
  ItineraryLineStops?: ItineraryLineStopInterface[];
}

export interface CarLoadInterface {
  users: number | null;
  occupation_percentage: number | null;
  update: string | null;
}

export interface ResumeItineraryInterface {
  lastUpdated?: string;
  way: number;
  stationName?: string;
  trains?: Array<{
    id: string;
    airConditioned: boolean;
  }>;
  position: Array<{
    position: {
      start: string;
      end: string;
      position: string;
      startId: string;
    };
    id: string;
    airConditioned: boolean;
    load?: {
      MA: CarLoadInterface;
      RA: CarLoadInterface;
      RB: CarLoadInterface;
      MB: CarLoadInterface;
    } | null;
  }>;
  nextArrives: Array<number>;
  nextArrivesFull: Array<{ time: number; trainId: string }>;
  nextTrain: string;
}

export interface ResumeItineraryBusInterface {
  lineName: string;
  linePrefix: string;
  lineColor: string;
  order: number;
  nextArrives: Array<{
    minutesToNextArrive: number;
    busArrival: string;
  }>;
}

export interface StopDepartureLineInterface {
  id: string;
  prefix: string;
  name: string;
  color: string;
}

export interface StopDepartureInterface {
  line: StopDepartureLineInterface;
  headsign: string;
  scheduledAt: string;
  estimatedAt: string | null;
  delaySeconds: number | null;
  realtime: boolean;
  order: number;
}

export interface StopDeparturesStopInterface {
  stopId: string;
  name: string;
  lat: number;
  lng: number;
}

export interface StopDeparturesInterface {
  stop: StopDeparturesStopInterface;
  departures: StopDepartureInterface[];
}

export interface CarFareInterface {
  value: number;
  vehicleType: string;
  sellingPointOnly?: boolean;
}
export interface SeatsInterface {
  id: string;
  floor: number;
  seatNumber: number;
  seatType: number;
  enabled: boolean;
  profileId: null | string;
  status: number;
  tokenId: null | string;
  position: number;
}
export interface TripsOfResumeItineraryVesselsInterface {
  tripScheduleId: string;
  shipName: string;
  sectionName: string;
  accessible: boolean;
  airConditioned: boolean;
  wifi: boolean;
  linePrefix: string;
  lineColor: string;
  open: string;
  start: string;
  close: string;
  end: string;
  extra: boolean;
  updated: boolean;
  fare: number;
  fareTax: number;
  fareRules: { operation: string; website?: { operation?: string } };
  carFares: CarFareInterface[];
  carFareTaxes: CarFareInterface[];
  lineSectionId: string;
  footCapacity: string;
  hasVehicle: boolean;
  hasPassenger: boolean;
  vehicleCapacity: string;
  seatFares?: SeatFaresFormInterface;
  boardingTax?: number;
  otherProfilesProducts: {
    id: string;
    name: string;
    taxValue: number;
    value: number;
    paymentTypeSingleTicket?: string;
  }[];
  otherProfiles: {
    id: string;
    name: string;
    taxValue: number;
    value: number;
  }[];
  TripScheduleProfileReservations: {
    profileId: string;
    profileName: string;
    quantity: number;
  }[];
  Tokens: {
    id: string;
    profileId: string;
  }[];
  seats: SeatsInterface[];
  showDepartureTimeOnly?: boolean;
}
export interface ResumeItineraryVesselsInterface {
  trips: TripsOfResumeItineraryVesselsInterface[];
  terminalName: string;
  // Dia (YYYY-MM-DD) das viagens retornadas
  date?: string;
  // Dia (YYYY-MM-DD) pedido na busca
  requestedDate?: string;
  // true quando o dia pedido não tinha viagens e as viagens são do próximo dia com viagens
  isNextAvailableDate?: boolean;
}

export interface ItineraryResumeTripCapacityList {
  id: string;
  footCapacity: string;
  sitCapacity: string;
  vehicleCapacity: string;
  vehicleEntries: string;
  footBookedEntries: string[];
  sitBookedEntries: string[];
  vehicleBookedEntries: string[];
  entriesAtMoment: string[];
  consumedBookedEntries: string[];
  sections: {
    [key: string]: {
      footCapacity: string;
      sitCapacity: string;
      vehicleCapacity: string;
      vehicleEntries: string;
      footBookedEntries: string;
      sitBookedEntries: string;
      vehicleBookedEntries: string;
      entriesAtMoment: string;
      consumedBookedEntries: string;
      conflictings: string[];
    };
  };
}

export interface VehicleLicenseInterface {
  brand: string;
  model: string;
  vehycleType: string;
  license: string;
}
export interface UserTransactionTokenInterface {
  id: string;
  createdAt: string;
  updatedAt: string;
  userTransactionId: string;
  tokenId: string;
  reschedules: number | null;
  amount: number;
  FareTaxIntegratorStock?: {
    id: string;
    number: string;
    lot: string;
    hasFreeIndicator: false;
    codeFareTax: string;
    createdAt: string;
    updatedAt: string;
    fareTaxValueId: string;
    fareTaxIntegratorId: string;
    entryId: null | string;
    sellingPointTransactionId: null | string;
    userTransactionTokenId: string;
  };
}
export interface PaymentRequestInterface {
  status: number;
  type: string;
  PaymentRequestHistories: {
    toStatus: number;
    fromStatus: number;
    message: string;
  }[];
}

export interface UserTransactionsInterface {
  UserTransactionToken: UserTransactionTokenInterface[];
  PaymentRequest: PaymentRequestInterface;
  amount: number;
}
export interface TripScheduleInterface {
  ScheduleMatrixConfig: {
    LineSection: {
      name: string;
      lineId: string;
      Section: {
        startId: string;
        endId: string;
      };
    };
  };
  date: string;
  open: string;
  start: string;
}
export interface TokenInterface {
  id: string;
  shortId: string;
  token: string;
  status: number;
  type: number;
  expiresAt: string;
  version: number;
  vehicleData: null;
  createdAt: string;
  updatedAt: string;
  userId: string;
  lineSectionId: string;
  tripScheduleId: string;
  UserTransactions: UserTransactionsInterface[];
  TripSchedule?: TripScheduleInterface;
}
export interface UserTrasactionInterface {
  id: string;
  type: number;
  createdAt: string;
  updatedAt: string;
  amount: number;
  paymentRequestId: string;
  transportOperatorId: string;
  userId: string;
  rescheduledTokenId: string;
  Tokens: {
    id: string;
    shortId: string;
    token: string;
    status: number;
    type: number;
    expiresAt: string;
    version: number;
    vehicleData: null;
    createdAt: string;
    updatedAt: string;
    userId: string;
    lineSectionId: string;
    tripScheduleId: string;
    UserTransactionToken: UserTransactionTokenInterface;
    UserTransactionTokens: UserTransactionTokenInterface[];
    TripSchedule: TripScheduleInterface;
    profileId: string;
    TripScheduleSeat: {
      id: '55a60c26-4901-421b-81ec-201ba0e5a40b';
      seatNumber: 1;
      floor: 1;
      seatType: 4;
      position: 0;
    };
  }[];
  PaymentRequest: PaymentRequestInterface;
}

export interface BpeListInterface {
  bpeGeneratedAt: string;
  tripStartedAt: string;
  tripClosedAt: string;
  route: number;
  id: string;
  ticketValue: number;
}

/*
 * State type
 */
export interface ItinerariesState {
  readonly itinerariesList: ItineraryInterface[];
  readonly itinerariesByWeekdaysList: any;
  readonly itineraryData: ItineraryInterface;
  readonly itineraryResumeList:
    | ResumeItineraryInterface[]
    | ResumeItineraryBusInterface[]
    | ResumeItineraryVesselsInterface;
  readonly itineraryResumeTripCapacityList: ItineraryResumeTripCapacityList[];
  readonly stopDepartures: StopDeparturesInterface | null;
  readonly currentLine: LineBaseInterface;
  readonly tokenList: TokenInterface[];
  readonly userTransactionList: UserTrasactionInterface[];
  readonly bpeList: BpeListInterface[];
  readonly vehicleLicense: VehicleLicenseInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly vehicleLicenseLoading: boolean;
  readonly vehicleLicenseCalled: boolean;
  readonly vehicleLicenseError: boolean;
  readonly isCompleted: boolean;
  readonly token: {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
  } | null;
  readonly error: boolean;
}
